import { builderDispatch, PrismUI, WebUI } from "../ui";
import { db } from "./db";
import { usePrismItemStore } from 'stores/usePrismItemStore';

/**
 * Uploads a file to the API.
 * @param {Object} upload - The upload object.
 * @param {File} compressedBlobAsFile - The compressed blob as a file.
 * @returns {Promise<void>} - A promise that resolves when the file is uploaded.
 */
export async function uploadFileToAPI(upload, compressedBlobAsFile) {
  const formData = buildFormData(compressedBlobAsFile, { uploadSource: 'uploadIndexedDB', target_album: null });
  formData.append('name', compressedBlobAsFile.name);
  formData.append('file', compressedBlobAsFile);
  
  let number_of_files = 0;
  let number_of_errors = 0;

  try {
    const response = await fetch(upload.uploadUrl, {
      method: 'POST',
      body: formData,
    });

    if (response.status !== 200) {
      number_of_files--;
      number_of_errors++;

      db.upload.update(upload.uuid, { status: 'error' });
      
      console.error('Error posting files to API', response);
    }

    number_of_files++;
  } catch (error) {
    number_of_files--;
    number_of_errors++;

    db.upload.update(upload.uuid, { status: 'error' });

    console.error('Error posting files to API', error);
  }
  
  if (number_of_errors > 0) {
    usePrismItemStore.setState(({ failedImagesUploaded}) => ({
      failedImagesUploaded: [...failedImagesUploaded, compressedBlobAsFile.name]
    }));
  } else {
    await db.upload.update(upload.uuid, { status: 'done' });
    await db.upload.delete(upload.uuid);
  }
}

/**
 * Builds a FormData object with the provided file and additional data.
 * @param {File} file - The file to be included in the FormData object.
 * @param {Object} additionalData - Additional data to be included in the FormData object.
 * @returns {FormData} The FormData object containing the file and additional data.
 */
function buildFormData(file, additionalData) {
  const formData = new FormData();
  const {
    uploadSource: uploadSourceOverride,
    ...otherParams
  } = additionalData;

  const uploadSource = uploadSourceOverride || 'livelink';

  formData.set('source', uploadSource);
  Object.entries(otherParams).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return formData;
}
